import { cn } from '@kss/ui';
import { useConfig } from '@kss/theme';

/** Brand wordmark — the OUTLET's logo and name, both admin-set in Settings and delivered as
 *  `config.logo` / `config.brand`. The mark used to be a fixed gradient tile, so a logo
 *  uploaded in Settings saved fine but never appeared on the storefront. */
export function Logo({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const { brand, logo } = useConfig();
  const name = brand?.trim() || 'ThaliOS';
  const tile = size === 'sm' ? 'h-[30px] w-[30px] rounded-[9px]' : 'h-[34px] w-[34px] rounded-[10px]';
  const text = size === 'sm' ? 'text-[15px]' : 'text-[17px]';
  return (
    <div className='flex items-center gap-2.5'>
      {logo ? (
        <img src={logo} alt='' className={cn('flex-shrink-0 object-cover', tile)} />
      ) : (
        <div
          className={cn('flex flex-shrink-0 items-center justify-center bg-[image:var(--gradient-primary)]', tile)}
        >
          <span className='block h-3 w-3 rotate-[-20deg] rounded-full border-[2.2px] border-white border-r-transparent' />
        </div>
      )}
      <span className={cn('max-w-[160px] truncate font-display font-bold tracking-tight text-content-primary', text)}>
        {name}
      </span>
    </div>
  );
}
